<template>
<div>
  <v-layout row class="mb-4 px-2">
    <v-flex
      xs12 lg10 offset-lg1 xl8 offset-xl2
      class="mt-2"
      v-if="kh"
    >
      <v-breadcrumbs large class="ml-1 pl-2" v-if="kh">
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item :to="{ name: 'khs' }">
          Alle Kreishandwerkerschaften
        </v-breadcrumbs-item>
        <v-breadcrumbs-item
          :to="{ name: 'khdetail', params: { id: kh.slug } }"
        >
          {{ kh.name }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      <v-layout row wrap>
        <v-flex xs12 sm9 class="pl-2">
          <h1 :class="ÜberschriftSize" class="hidden-xs-only">{{ kh.name }}</h1>
        </v-flex>
        <v-flex xs12 sm3  class="text-xs-right" v-if="kh.logo">
           <v-avatar
            size="120"
            color="grey lighten-4"
            >
              <img :src="kh.logo" :alt="kh.name + ' logo'">
            </v-avatar>
        </v-flex>
        <!-- <v-flex v-if="gewerk.text" class="mt-3">
          <span v-html="gewerk.text" class="subheading"></span>
        </v-flex> -->
      </v-layout>  
    </v-flex>
  </v-layout>
      <v-layout row>
      <v-flex>
        <v-img
          src="././img/tmp/bg1.webp"
          min-height="320px"
          max-height="390px"
          alt="Handwerker BG"
          cover
          dark
          lazy-src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAICAgICAgICAgIDAgICAwQDAgIDBAUEBAQEBAUGBQUFBQUFBgYHBwgHBwYJCQoKCQkMDAwMDAwMDAwMDAwMDAz/2wBDAQMDAwUEBQkGBgkNCgkKDQ8ODg4ODw8MDAwMDA8PDAwMDAwMDwwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCABUACYDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/9k="
        >
          <v-layout row wrap align-center justify-center fill-height >
            <div v-if="kh" style="min-width: 680px;">
              <kh-autocomplete
                :key="kh.id"
                :kh="kh"
              ></kh-autocomplete>
            </div>
          </v-layout>
        </v-img>
      </v-flex>
    </v-layout>
<v-layout row>
  <v-flex  xs12 lg10 offset-lg1 xl8 offset-xl2>
<v-layout row wrap class="mt-4">
  <v-flex xs12 sm12 md8 order-xs2 order-sm1
    v-if="kh.text" 
    class="subheading px-3" 
    v-html="kh.text"
  >
  </v-flex>
  <v-flex xs12 sm12 md4 order-xs1 order-sm2 class="mb-3">
     <v-layout row>
    <v-flex xs12 class="px-2" >
      <v-card class="light-blue darken-4"> 
          <v-layout
            column
            fill-height
          >
            <v-spacer></v-spacer>
            <v-card-title class="white--text pl-3 pt-2">
              <div class="headline pl-0 pt-3">{{ kh.name }}</div>
            </v-card-title>
          </v-layout>
        <v-list two-line>
          <v-list-tile v-if="kh.telefon" :href="'tel:' + kh.telefon">
            <v-list-tile-action>
              <v-icon color="light-blue darken-4">phone</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ kh.telefon }}</v-list-tile-title>
              <v-list-tile-sub-title>Telefon</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset v-if="kh.email"></v-divider>
          <v-list-tile v-if="kh.email" v-bind:href="'mailto:' + kh.email">
            <v-list-tile-action>
               <v-icon color="light-blue darken-4">mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ kh.email }}</v-list-tile-title>
              <v-list-tile-sub-title>E-Mail</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset v-if="kh.website"></v-divider>
          <v-list-tile v-if="kh.website" :href="kh.website" target="_blank">
            <v-list-tile-action>
              <v-icon color="light-blue darken-4">web</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > 
               {{ kh.website }}
              </v-list-tile-title>
              <v-list-tile-sub-title>Webseite</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset v-if="kh.adresse"></v-divider>
          <v-list-tile v-if="kh.adresse">
            <v-list-tile-action>
              <v-icon color="light-blue darken-4">location_on</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ kh.adresse }}</v-list-tile-title>
              <v-list-tile-sub-title>Adresse</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
           <v-divider inset></v-divider>
           <v-list-tile>
            <v-list-tile-action>
              <v-icon color="light-blue darken-4">location_city</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ kh.stadt }}</v-list-tile-title>
              <v-list-tile-sub-title>Stadt</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
  </v-flex>
</v-layout>
</v-flex>
</v-layout>
<v-layout row :style="SkylineMargin">
    <v-flex
      xs12 lg10 offset-lg1 xl8 offset-xl2
      style="z-index: 3; margin-bottom: 0px;"
      class="mt-2"
      v-if="kh"
    >
    <v-layout class="mt-5" row wrap v-if="kh.innungen.length > 0">
      <v-flex class="pl-3">
        <h3 class="display-1">Innungen</h3>
      </v-flex>
    </v-layout>
     <v-container fluid grid-list-lg v-if="kh.innungen.length > 0">
        <v-layout row wrap fill-height>
          <v-flex 
            xs12 
            sm6 
            md4 
            grow
            v-for="innung in kh.innungen" 
            :key="innung.id"
          >
            <innung-card :innung="innung"></innung-card>
          </v-flex>
        </v-layout>
     </v-container>
    </v-flex>
  </v-layout>

  <div v-if="kh">
    <bottom-banner v-if="kh.skyline" :skyline="kh.skyline" :slug="kh.slug"></bottom-banner>
  </div>
  </div>
</template>

<script>
import axios from 'axios'

import { mapGetters } from 'vuex'
// import GewerkAutocomplete from '~/components/gewerke/GewerkAutocomplete.vue'

import InnungCard from '~/components/gewerke/InnungCardColumn.vue'
import BottomBanner from '~/components/kreishandwerkerschaften/BottomBanner.vue'

import KhAutocomplete from '~/components/kreishandwerkerschaften/KHAutocomplete.vue'

export default {
  components: {
    KhAutocomplete,
    InnungCard,
    BottomBanner
  },
  data () {
    return {
      showcontact: false,
      // stelle: '',
      kh: '',
      gewerk: null,
      busy: false,
      bewerben: false
    }
  },
  filters: {
  },
  created () {
  },
  mounted () {
    // console.log('stelle: ' + this.stelle.titel)
  },

  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    }),
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'headline'
      } else {
        return 'display-3'
      }
    },
    SkylineMargin: function () {
      if (this.kh) {
        if (this.kh.skyline) {
          return 'margin-bottom: -80px;'
        }
      } else {
        return 'margin-bottom: 30px;'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/v1/kreishandwerkerschaft/' + to.params.id)
      .then(resp => {
        next(vm => {
          vm.kh = resp.data
        })
      })
      .catch(error => {
        console.log(error)
        next({ name: '404' })
      })
  },
  beforeRouteUpdate (to, from, next) {
    axios
      .get('/api/v1/kreishandwerkerschaft/' + to.params.id)
      .then(resp => {
        this.setData(resp.data)
        // app.anzeige = resp.data
        next()
        // next(vm => (vm.anzeige = resp.data))
      })
      .catch(error => {
        console.log(error)
        next({ name: '404' })
      })
  },
  methods: {
    setData (data) {
      this.kh = data
    }
  },
  metaInfo () {
    if (this.kh) {
      if (this.kh.text) {
        return {
          title: this.kh.name + ' auf LokalesHandwerk.de - Finden Sie Ihren Fachbetrieb',
          meta: [
            { name: 'description', content: this.kh.text }
          ]
        }
      } else {
        return {
          title: this.kh.name + ' auf LokalesHandwerk.de'
        }
      }
    }
  }
}
</script>

<style scoped>
.listbg {
  background: white;
}

.tileright {
  align-items: flex-end;
}

.line-height {
  line-height: 1.5 !important;
}
</style>
